export default __webpack_public_path__ + "static/lozenge-icon-dont-dark-07d4ec7a487924bae4480b8262df05c0.png";